<script setup lang="ts">
import type { DataTableHeaders } from '@/plugins/vuetify'
import type { TBCustomer } from '@/types/thingsboard'
import type { HDHTTPDevice } from '@/types/httpdevices'

definePage({
  meta: {
    icon: 'mdi-devices',
    title: 'HTTP Devices',
    drawerIndex: 99,
    requiresAuth: true,
    requiresAdmin: true
  },
})

const router = useRouter()
//const storeU = useUtilisateurStore()
//const estChargé = computed(() => storeU.estChargé())

let tbToken = null as string | null

const customers = ref([] as TBCustomer[])
const selectedCustomer = ref(null as TBCustomer | null)
const selectedCustomerName = ref('')
const customerNames = computed(() => customers.value.map(c => c.name))

const devices = ref([] as HDHTTPDevice[])
const selectedDevice = ref(null as HDHTTPDevice | null)
//const selectedDeviceName = ref('')
//const deviceNames = computed(() => devices.value.map(d => d.name))

const search = ref('');
const headers: DataTableHeaders = [
  { title: 'Nom', key: 'name', width: '150px' },
  { title: 'TB ID', key: 'thingsBoardId', width: '300px' },
  { title: 'TB Customer ID', key: 'thingsBoardCustomerId', width: '300px' },
  { title: 'Actions', key: 'actions', sortable: false }
]

function newHTTPDevice() {
  router.push(`/httpdevices/${selectedCustomer.value?.id.id}/0`)
}

function editHTTPDevice(device: HDHTTPDevice) {
  router.push(`/httpdevices/${selectedCustomer.value?.id.id}/${device.id}`)
}

const dialogDelete = useTemplateRef('dialogDelete')
async function deleteHTTPDevice(device: HDHTTPDevice) {
  if (selectedCustomer.value == null) {
    Notify.error('Aucun client sélectionné')
    return
  }

  const result = await dialogDelete.value?.open('Êtes-vous certain de vouloir supprimer cet appareil ?');
  if (!result?.valueOf())
    return

  try {
    const customerId = selectedCustomer.value.id.id
    await apiOmni.delete(`customers/${customerId}/httpdevices/${device.id}`)
    Notify.success('Supprimé')
    await loadDevices()
  } catch (e) {
    Notify.error(e)
  }
}

const onCustomerChanged = async (value: string) => {
  selectedCustomer.value = customers.value.find(c => c.name === value) ?? null
  loadDevices()
}

async function loadDevices() {
  if (selectedCustomer.value === null) {
    return
  }

  selectedDevice.value = null
  devices.value = []

  const customerId = selectedCustomer.value.id.id
  const response = await apiOmni.get(`customers/${customerId}/httpdevices`)
  devices.value.push(...response.data)
  console.log(devices.value)

  return null
}

onMounted(async () => {
  try {
    const response = await apiOmni.post('api/tb/login')
    tbToken = response.data.token

    selectedCustomer.value = null
    customers.value = []

    for (let i = 0; ; ++i) {
      const config2 = {
        headers: { 'X-ThingsBoard': `Bearer ${tbToken}` },
        params: { page: i, pageSize: 25
      }}
      const response2 = await apiOmni.get('api/tb/customers', config2)
      customers.value.push(...response2.data.data)
      if (response2.data.hasNext === false) {
        break
      }
    }

    if (customers.value.length > 0) {
      selectedCustomer.value = customers.value[0]
      selectedCustomerName.value = selectedCustomer.value.name
    }

    //console.log(customers.value)

  } catch (error) {
    console.log('Error:', error)
    Notify.error(error)
  }

  loadDevices()
})
</script>

<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="2">
        <v-icon>mdi-devices</v-icon>
        <span>{{ selectedCustomer?.name ?? 'Aucun sélectionné' }}</span>

      </v-col>
      <v-col cols="2">
        <v-select
          v-model="selectedCustomerName"
          :items="customerNames"
          label="Site"
          hide-details
          dense
          outlined
          class="mr-2"
          style="width: 300px"
          @update:model-value="onCustomerChanged"
        />
      </v-col>
    </v-row>
    <v-row width="100%">
      <v-col>
        <v-card>
          <v-data-table :headers="headers" :items="devices" :search="search" item-key="id">
            <template #top>
              <v-toolbar flat>
                <v-toolbar-title>Devices {{ selectedCustomerName }}</v-toolbar-title>
                <v-divider class="mx-4" inset vertical/>
                <v-spacer/>
                <v-btn class="mb-2" color="primary" @click="newHTTPDevice">Nouvel appareil</v-btn>
              </v-toolbar>
            </template>
            <template #item.actions="{ item }">
              <v-icon class="me-2" size="small" @click="editHTTPDevice(item)">
                mdi-pencil
              </v-icon>
              <v-icon size="small" @click="deleteHTTPDevice(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  <DialogConfirm ref="dialogDelete" />
</template>
